import { useEffect } from "react";

import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/leaveActions";

const LeaveSettings = ({
	leaveTypes,
	getLeaveTypes,
	toggleLeavePermissions,
	saveLeavePermissions,
	getLeaveSettings,
	updateSetting,
	disabled,
	// jurisdiction,
	addMultiOptionField,
}) => {
	useEffect(() => {
		getLeaveTypes();
		getLeaveSettings();
	}, []);

	return (
		<form
			className="px-8"
			onSubmit={(e) => {
				e.preventDefault();
				e.stopPropagation();
				saveLeavePermissions();
			}}
		>
			<div className="col-xs-12 form-section">
				<div className="col-xs-12 form-container">
					<div className="pull-left">
						<h4>Leave Types</h4>
					</div>
					<div className="pull-right">
						{!disabled && (
							<button
								className="btn btn-success pull-right"
								type="button"
								id="add-allowance-type"
								onClick={() => {
									addMultiOptionField("leaveTypes");
								}}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Add Custom Leave Type</div>
							</button>
						)}
					</div>
				</div>
				<div style={{ width: "100%", overflow: "auto" }}>
					<table
						id="table-timesheets"
						className="js-table-sections table table-hover"
					>
						<thead>
							<tr>
								<th>Leave Type</th>
								<th>Manager can Apply/Approve</th>
								<th>Employee can Apply</th>
								<th>Show Balance in Portal</th>
								<th>Can Apply Only if Balance Available</th>
							</tr>
						</thead>
						<tbody>
							{leaveTypes?.map((leaveType) => (
								<tr key={leaveType.id}>
									<td>
										{!leaveType.temporary ? (
											leaveType.name
										) : (
											<div className="form-material">
												<input
													className="form-control form-input"
													name="name"
													value={leaveType?.name}
													onChange={(e) =>
														updateSetting(
															e.target.name,
															e.target.value,
															"leaveTypes",
															leaveType?.id,
														)
													}
													disabled={disabled}
												/>
											</div>
										)}
									</td>
									<td>
										<label
											className="css-input switch switch-sm switch-success"
											onClick={(e) => {
												if (!disabled) {
													e.stopPropagation();
													e.preventDefault();
													toggleLeavePermissions(leaveType.id, "managerCanApprove");
												}
											}}
										>
											<input
												name="mode"
												disabled={disabled}
												type="checkbox"
												checked={leaveType.managerCanApprove}
											/>
											<span />
										</label>
									</td>
									<td>
										<label
											className="css-input switch switch-sm switch-success"
											onClick={(e) => {
												if (!disabled) {
													e.stopPropagation();
													e.preventDefault();
													toggleLeavePermissions(leaveType.id, "employeeCanApply");
												}
											}}
										>
											<input
												name="mode"
												disabled={disabled}
												type="checkbox"
												checked={leaveType.employeeCanApply}
											/>
											<span />
										</label>
									</td>
									<td>
										<label
											className="css-input switch switch-sm switch-success"
											onClick={(e) => {
												if (!disabled) {
													e.stopPropagation();
													e.preventDefault();
													toggleLeavePermissions(leaveType.id, "showBalance");
												}
											}}
										>
											<input
												name="mode"
												disabled={disabled}
												type="checkbox"
												checked={leaveType.showBalance}
											/>
											<span />
										</label>
									</td>
									<td>
										<label
											className="css-input switch switch-sm switch-success"
											onClick={(e) => {
												if (!disabled) {
													e.stopPropagation();
													e.preventDefault();
													toggleLeavePermissions(leaveType.id, "applyIfBalanceAvailable");
												}
											}}
										>
											<input
												name="mode"
												disabled={disabled}
												type="checkbox"
												checked={leaveType.applyIfBalanceAvailable}
											/>
											<span />
										</label>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="clearfix" />
			</div>

			<div
				className="col-xs-12 pr-0"
				style={{ paddingBottom: "8rem" }}
			>
				{!disabled && (
					<button
						className="btn btn-success pull-right"
						type="submit"
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Save</div>
					</button>
				)}
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {

	return {
		jurisdiction: state.company?.settings?.jurisdiction,
		leaveTypes: state.leave.leaveTypes,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
	};
};

const mapDispatchToProps = (dispatch) => ({
	saveLeavePermissions: () => dispatch(ACTIONS.saveLeavePermissions()),
	getLeaveSettings: () => dispatch(ACTIONS.getLeaveSettings()),
	getLeaveTypes: () => dispatch(ACTIONS.getLeaveTypes()),
	toggleLeavePermissions: (leaveType, permission) => dispatch(ACTIONS.toggleLeavePermissions(leaveType, permission)),
	addMultiOptionField: (field) => dispatch(ACTIONS.addMultiOptionField({ parent: null, newCompany: false, field })),
	updateSetting: (field, newValue, fieldType, id) => dispatch(ACTIONS.updateSetting(field, newValue, fieldType, id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveSettings);
